import React, { Component } from 'react';
import { SimpleForm, TextInput, Toolbar, SaveButton, ReferenceInput, SelectInput, translate } from 'react-admin';
import FieldGroup from '~components/FieldGroup';
import { isRequired } from '~utils/inputValidations';

function SubsectorToolbar(props) {
  return (
    <Toolbar {...props}>
      <SaveButton />
    </Toolbar>
  );
}

class SubsectorForm extends Component {
  render() {
    return (
      <SimpleForm {...this.props} toolbar={<SubsectorToolbar />}>
        {this.props.children}
        <FieldGroup label="fieldGroups.subsectorEs">
          <TextInput source="name" validate={isRequired} />
        </FieldGroup>
        <FieldGroup label="fieldGroups.subsectorEn">
          <TextInput source="nameEn" />
        </FieldGroup>
        <FieldGroup label="fieldGroups.subsectorPt">
          <TextInput source="namePt" />
        </FieldGroup>
        <FieldGroup label="fieldGroups.subsector">
          <ReferenceInput source="sector" reference="sectores" validate={isRequired}>
            <SelectInput optionText="name" />
          </ReferenceInput>
        </FieldGroup>
      </SimpleForm>
    );
  }
}

export default translate(SubsectorForm);
